import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import messages from "../../../assets/locale/messages";
import DeleteModal from "../../../components/DeleteModal";
import {
  deleteFlashCardSubTopicRequest,
  deleteFlashCardTopicRequest
} from "../../../store/FlashCard/Topics/actions";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const TopicsDelete = ({
  isSubTopic,
  isOpen,
  lang,
  id,
  setDeleteModal,
  nameTopicOrSubTopic
}) => {
  const intl = useIntl();
  console.log("nameTopicOrSubTopic", nameTopicOrSubTopic);
  const { topicId } = useParams();
  const message = intl.formatMessage(
    { id: "deleteMessage" },
    { entity: nameTopicOrSubTopic }
  );
  const dispatch = useDispatch();

  const {
    flashcard: {
      topic: { deleteTopic },
      subTopic: { deleteSubTopic }
    }
  } = messages[lang];
  // deleteMessage: deleteSubMessage
  const handleDelete = () => {
    isSubTopic
      ? dispatch(deleteFlashCardSubTopicRequest({ topicId, id }))
      : dispatch(deleteFlashCardTopicRequest(id));
    setDeleteModal({ id: 0, name: "", open: false });
  };

  return (
    <DeleteModal
      deleteTitle={isSubTopic ? deleteSubTopic : deleteTopic}
      deleteMessage={isSubTopic ? message : message}
      isOpen={isOpen}
      lang={lang}
      handleDelete={handleDelete}
      handleCancel={() => setDeleteModal({ id: 0, open: false })}
    />
  );
};

TopicsDelete.propTypes = {
  isOpen: PropTypes.bool,
  isSubTopic: PropTypes.bool.isRequired,
  lang: PropTypes.string,
  id: PropTypes.number,
  setDeleteModal: PropTypes.func,
  nameTopicOrSubTopic: PropTypes.string.isRequired
};

TopicsDelete.defaultProps = {
  isOpen: false,
  nameTopicOrSubTopic: ""
};

export default TopicsDelete;
